var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcFcb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 29,
    viewBox: "0 0 14 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F7465F",
    fillRule: "evenodd",
    d: "M14 10.086H9.311v-2.8c0-1.445.112-2.355 2.08-2.355h2.484V.479a32.958 32.958 0 0 0-3.642-.193c-3.609 0-6.242 2.32-6.242 6.578v3.222H0v5.6l3.99-.002v12.602h5.321V15.682l4.078-.002.611-5.594z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFcb);
export default __webpack_public_path__ + "static/media/ic-fcb.3d1bea75ba9a855617b3fc8b7eab77be.svg";
export { ForwardRef as ReactComponent };